import React, { useCallback, useEffect, useMemo, useState } from "react";
import Sidebar from "./Sidebar";
import { getPopoverByName } from "../../../utils";
import TextScript from "./script/TextScript";
import { selectSubTab } from "../../../store/common/uiSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import GenerateScriptWithAI from "./script/GenerateScriptWithAI";
import AudioScript from "./script/AudioScript";
import { LANGUAGE_DATA } from "../../../constants/scriptConfig";
import { getSubtitles } from "../../../thunks/editor/scriptThunks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { updateSubtitle } from "../../../store/slides/slidesSlice";
const SelectCaption = ({ setShowSubtitle }) => {
  const dispatch = useDispatch();
  const tooltipStyle = {
    position: "relative",
    display: "inline-block",
  };

  const tooltipTextStyle = {
    visibility: "hidden",
    width: "320px",
    backgroundColor: "black",
    color: "#fff",
    textAlign: "center",
    borderRadius: "6px",
    padding: "5px",
    position: "absolute",
    zIndex: 1,
    top: "150%",
    left: "20%",
    marginLeft: "-60px",
    opacity: 0,
    transition: "opacity 0.3s",
  };

  const tooltipTextStyleVisible = {
    ...tooltipTextStyle,
    visibility: "visible",
    opacity: 1,
  };

  const [isTooltipVisible, setTooltipVisible] = React.useState(false);
  const [showCaptionWindow, setShowCaptionWindow] = React.useState(false);

  const { subtitles } = useSelector((state) => state.script);
  const handleNextClick = () => {
    setShowCaptionWindow(true);
  };

  useEffect(() => {
    if (showCaptionWindow) {
      dispatch(getSubtitles());
    }
  }, [showCaptionWindow]);

  const handleMouseEnter = (e) => {
    const { currentTime, paused, ended } = e?.target || {};
    const isPlaying = currentTime && !paused && !ended;
    if (!isPlaying) {
      const vid = e.target;
      vid.muted = true;
      vid.play();
    }
  };
  const handleMouseLeave = (e) => {
    const { currentTime, paused, ended } = e?.target || {};
    const isPlaying = currentTime && !paused && !ended;
    if (isPlaying) {
      const vid = e.target;
      vid.muted = false;
      vid.currentTime = 0;
      vid.pause();
    }
  };

  const onBack = () => {
    if (showCaptionWindow) {
      setShowCaptionWindow(!showCaptionWindow);
    } else {
      setShowSubtitle(false);
    }
  };

  const onVideoSelect = (id) => {
    dispatch(updateSubtitle(id));
    setShowCaptionWindow(!showCaptionWindow);
    setShowSubtitle(false);
  };

  return (
    <div>
      <div className="w-full px-2 py-2 text-sm bg-gray-200 text-gray-700 flex items-center">
        <FontAwesomeIcon
          icon={faArrowLeft}
          onClick={onBack}
          className="mr-2 p-1 h-4 border-gray-500 border rounded-lg cursor-pointer"
        />
        <span className="text-gray-500 cursor-pointer" onClick={onBack}>
          BACK{" "}
        </span>
      </div>
      {!showCaptionWindow ? (
        <div className="text-1 flex flex-col justify-between">
          <div className="flex pt-4 px-2">
            <div className="w-[50%]">
              <h1 className="font-bold">Select language spoken in video</h1>
              <select
                className="w-[70%] mr-2 p-2 rounded mt-2 border "
                disabled={true}
                defaultValue={"English (United Kingdom)"}
              >
                {LANGUAGE_DATA.map((language) => (
                  <option key={language}>{language.language}</option>
                ))}
              </select>
              <div
                style={tooltipStyle}
                onMouseEnter={() => setTooltipVisible(true)}
                onMouseLeave={() => setTooltipVisible(false)}
              >
                <button className="font-serif text-sm w-[20px] border-black border-2 h-[20px] rounded-full">
                  i
                </button>
                <span
                  style={
                    isTooltipVisible
                      ? tooltipTextStyleVisible
                      : tooltipTextStyle
                  }
                >
                  This feature has temporarily been disabled due to technical
                  reasons.
                </span>
              </div>
            </div>

            <div className="w-[50%]">
              <h1 className="font-bold">Select subtitle language</h1>
              <select
                className="w-[80%] p-2 rounded mt-2 border"
                defaultValue={"English (United Kingdom)"}
              >
                {LANGUAGE_DATA.map((language) => (
                  <option key={language}>{language.language}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="mt-[250px] w-full flex justify-end">
            <button
              onClick={handleNextClick}
              className="rounded bg-[#11142D] p-1 w-[30%] text-white px-4 mr-4"
            >
              Next
            </button>
          </div>
        </div>
      ) : (
        <>
          <div className="Captionwindow border-2 h-[300px] mr-4 ml-2 mt-4 p-2 rounded-md">
            <div className="flex flex-wrap gap-2 w-full h-full overflow-y-scroll pt-4">
              <div className="w-[150px]">
                <div className="w-full rounded bg-gray-200 py-8 h-[80px]"></div>
                <h1 className="text-center">None</h1>
              </div>
              {subtitles.map((sub, index) => {
                return (
                  <div
                    className="w-[150px] rounded cursor-pointer"
                    onClick={() => onVideoSelect(sub.id)}
                  >
                    <video
                      src={sub.previewUrl}
                      alt={`${index}`}
                      className="h-[80px] w-full object-cover"
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    />
                    <h1 className="text-center">{index + 1} Title</h1>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="flex w-full mt-4 justify-end">
            <button className="p-1 rounded bg-[#11142D] text-white  w-[200px] mr-4">
              Apply style
            </button>
          </div>
        </>
      )}
    </div>
  );
};
const ScriptPopover = () => {
  const [voiceSelectorVisible, setVoiceSelectorVisible] = useState(false);
  const [showSubtitle, setShowSubtitle] = useState(false);
  const dispatch = useDispatch();
  const trial = useSelector((state) => state?.user?.details?.data?.trial);
  const { slides, currentSlideIndex } = useSelector((state) => state.slides);
  const { isDoc, isLinkVideo } = useSelector((state) => state.project);
  const currentSlide = useMemo(
    () => slides[currentSlideIndex],
    [currentSlideIndex, slides]
  );
  const isDidAvatar = currentSlide?.objects?.some((slide) => {
    return slide.type === "avatar" && slide.url.includes("d-id");
  });
  const thisPopover = getPopoverByName("Script", trial);
  const { subTab, audioSubTab } = useSelector((state) => state.ui);
  const isAudioScript = useMemo(() => subTab === 1, [subTab]);

  const onTabSelect = useCallback(
    (tabIndex) => {
      dispatch(selectSubTab(tabIndex));
    },
    [dispatch]
  );

  return (
    <>
      {/* {showSubtitle && (
        <>
          <SelectCaption setShowSubtitle={setShowSubtitle} />
        </> */}
      <div
        className={`flex w-full h-full ${
          isDoc || isLinkVideo
            ? "max-w-full mt-[22px] !max-h-[450px] "
            : "max-w-full"
        }`}
      >
        {!voiceSelectorVisible && !isDoc && !isLinkVideo && !showSubtitle && (
          <Sidebar
            titleIcon={"/tool/dashboard/static/images/icons/tools/script.svg"}
            title={"Script"}
            tabs={thisPopover.tabs.filter(
              (t) => !(t.name === "Audio Script" && isDidAvatar)
            )}
            onTabSelect={onTabSelect}
            uploadButton={
              !isDidAvatar && !!isAudioScript && { ...thisPopover.uploadButton }
            }
          />
        )}

        {/* <div
          className={`flex w-full h-full ${
            isDoc || isLinkVideo
              ? "max-w-[550px] mt-[22px] h-[380px] "
              : "max-w-full"
          }`}
        >
          {subTab === 0 && (
            <TextScript
              voiceSelectorVisible={voiceSelectorVisible}
              setVoiceSelectorVisible={setVoiceSelectorVisible}
              voiceOptionClassName={
                isDoc ? "!grid-cols-3 max-h-[calc(100%_-_120px)]" : ""
              }
            />
          )} */}
        {!showSubtitle && (
          <div
            className={`px-2 py-4 ${
              voiceSelectorVisible || isDoc || isLinkVideo
                ? "w-full !p-0"
                : "w-4/5"
            }  ${
              isDoc || isLinkVideo ? "border rounded-lg !p-2" : ""
            } bg-gray-100 overflow-auto`}
          >
            {subTab === 0 && (
              <TextScript
                voiceSelectorVisible={voiceSelectorVisible}
                setVoiceSelectorVisible={setVoiceSelectorVisible}
                setShowSubtitle={setShowSubtitle}
                voiceOptionClassName={
                  isDoc || isLinkVideo
                    ? "!grid-cols-3 max-h-[calc(100%_-_120px)]"
                    : ""
                }
              />
            )}
            {isAudioScript && <AudioScript />}
            {/* {subTab === 2 && <SelectCaption />} */}
          </div>
        )}
        {/* </div> */}
      </div>
    </>
  );
};

export default ScriptPopover;
